import { COUNTS_LIST_LOADED, DATA } from './types';

const initialState = {
  count: [],
  pagination: {},
  listIsLoaded: false
};

export default function (state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case DATA:
      return { ...state, count: payload.data, pagination: payload.pagination };
    case COUNTS_LIST_LOADED:
      return { ...state, listIsLoaded: payload };
    default:
      return state;
  }
};